export function compareContents(a, b) {
  const orderA = a.order ?? 0;
  const orderB = b.order ?? 0;
  if (orderA !== orderB) return orderA - orderB;
  return new Date(b.created_at) - new Date(a.created_at);
}

export function sortContents(contents) {
  return [...contents].sort(compareContents);
}

export function sortCategories(categories) {
  return [...categories].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

export function groupContentsByCategory(contents, categories) {
  const sortedCategories = sortCategories(categories);
  const byCategory = Object.fromEntries(sortedCategories.map((cat) => [cat.id, []]));

  for (const content of contents) {
    if (byCategory[content.category_id]) {
      byCategory[content.category_id].push(content);
    }
  }

  return sortedCategories.map((category) => ({
    category,
    items: sortContents(byCategory[category.id] || []),
  }));
}

/** Categorie con almeno un contenuto, ordinate come in admin. */
export function getNonEmptyCategoryGroups(contents, categories) {
  return groupContentsByCategory(contents, categories).filter(({ items }) => items.length > 0);
}

export function sortContentsForAdmin(contents, categories) {
  const categoryOrder = Object.fromEntries(
    categories.map((cat, index) => [cat.id, cat.order ?? index])
  );
  return [...contents].sort((a, b) => {
    const catA = categoryOrder[a.category_id] ?? 999;
    const catB = categoryOrder[b.category_id] ?? 999;
    if (catA !== catB) return catA - catB;
    return compareContents(a, b);
  });
}

export function compareFaqs(a, b) {
  const orderA = a.order ?? 0;
  const orderB = b.order ?? 0;
  if (orderA !== orderB) return orderA - orderB;
  return String(a.created_at || '').localeCompare(String(b.created_at || ''));
}

export function getListMoveState(sortedItems, itemId) {
  const index = sortedItems.findIndex((item) => item.id === itemId);
  return {
    canMoveUp: index > 0,
    canMoveDown: index >= 0 && index < sortedItems.length - 1,
  };
}

export function getFaqMoveState(faqs, faqId) {
  const siblings = [...faqs].sort(compareFaqs);
  return getListMoveState(siblings, faqId);
}

export function getFaqCategoryMoveState(categories, categoryId) {
  const sorted = sortCategories(categories);
  return getListMoveState(sorted, categoryId);
}

export function compareContacts(a, b) {
  const orderA = a.order ?? 0;
  const orderB = b.order ?? 0;
  if (orderA !== orderB) return orderA - orderB;
  return String(a.created_at || '').localeCompare(String(b.created_at || ''));
}

export function sortContacts(contacts) {
  return [...contacts].sort(compareContacts);
}

export function getContactMoveState(contacts, contactId) {
  const sorted = sortContacts(contacts);
  return getListMoveState(sorted, contactId);
}

export function getCategoryMoveState(categories, categoryId) {
  return getFaqCategoryMoveState(categories, categoryId);
}

export function getContentMoveState(contents, contentId) {
  const item = contents.find((c) => c.id === contentId);
  if (!item) return { canMoveUp: false, canMoveDown: false };
  const siblings = sortContents(contents.filter((c) => c.category_id === item.category_id));
  return getListMoveState(siblings, contentId);
}
